import { Check } from 'lucide-react';
import {
  DEFAULT_STATES,
  FALLBACK_COLOR,
  STATUS_COLORS,
  STATUS_META,
  humanizeState,
} from './timeline-constants';

interface TimelineProgressChipsProps {
  currentState: string;
  seenStates: Set<string>;
}

export default function TimelineProgressChips({
  currentState,
  seenStates,
}: TimelineProgressChipsProps) {
  return (
    <div className="mt-5 pt-4 border-t border-slate-100">
      <p className="mb-2 text-[11px] font-medium uppercase tracking-wide text-slate-400">
        Order Progress
      </p>
      <div className="flex flex-wrap gap-1.5 sm:gap-2">
        {DEFAULT_STATES.map((state) => {
          const meta = STATUS_META[state];
          const colors = STATUS_COLORS[state] ?? FALLBACK_COLOR;
          const isCurrent = state === currentState;
          const isSeen = seenStates.has(state);

          return (
            <span
              key={state}
              className={[
                'inline-flex items-center gap-1 h-6 rounded-full border px-2 text-[11px] font-medium whitespace-nowrap',
                isCurrent
                  ? `${colors.chipActive} ring-1 ring-offset-1 ring-blue-300`
                  : isSeen
                  ? colors.chipSeen
                  : 'border-slate-200 bg-white text-slate-400',
              ].join(' ')}
            >
              {isSeen && !isCurrent && <Check className="h-3 w-3" />}
              {meta?.title ?? humanizeState(state)}
            </span>
          );
        })}
      </div>
    </div>
  );
}
